module.exports = ":host .warning-note{display:inline-flex}:host .font-bold{font-weight:bold}:host .padding-inline-start25px{padding-inline-start:25px}"